import React, { useState } from 'react';

const CreateGroupModal = ({ treeCount, jobName, onClose, onSubmit }) => {
  const [name, setName] = useState(`Group — ${jobName || 'Job'}`);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name) return;
    onSubmit({ name });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>Create tree group</h2>
        <p style={{ fontSize: 14, color: '#666', margin: '0 0 16px' }}>
          {treeCount} trees selected. A bounding polygon will be drawn around them.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Group name</label>
            <input value={name} onChange={(e) => setName(e.target.value)} required />
          </div>
          <div className="modal-actions">
            <button type="button" className="btn btn-secondary btn-touch" style={{ color: '#333', background: '#eee' }} onClick={onClose}>Cancel</button>
            <button type="submit" className="btn btn-primary btn-touch">Create group</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateGroupModal;
